export const WHITELABEL = process.env.WHITELABEL || 'pixDoMilhao';
export const API_URL =
  process.env.NEXT_PUBLIC_API_URL || 'https://api-hml2.ilotto.com.br';
export const EXATO_DIGITAL_API_KEY = process.env.NEXT_PUBLIC_EXATO_DIGITAL_API_KEY || '';
export const API_INTERNAL_URL = process.env.API_INTERNAL_URL || '';

export const getServerApiBaseUrl = (): string => {
  return process.env.API_INTERNAL_URL || API_URL;
};
